import { createContext } from 'react';
import type { SignInCredential, AuthResult, User } from '@/@types/auth';

type Auth = {
  authenticated: boolean;
  user: User | null;
  signIn: (values: SignInCredential) => AuthResult;
  signOut: () => void;
};

const defaultFunctionPlaceHolder = async (): AuthResult => {
  await new Promise((resolve) => setTimeout(resolve, 0));
  return {
    status: '',
    message: '',
  };
};

const AuthContext = createContext<Auth>({
  authenticated: false,
  user: null,
  signIn: async () => defaultFunctionPlaceHolder(),
  signOut: () => {},
});

export default AuthContext;
